import { Component, ChangeDetectionStrategy, ViewChild } from "@angular/core";
import { filter, Observable } from "rxjs";
import { Store } from "@ngrx/store";

import { Strings } from "../app.constants";
import { ConsultationProcess } from "../data/model";
import { ZASConstants } from "../data/model.constants";
import { PersistenceService } from "../store/model/persistence.service";
import { AgentValidity } from "../store/validity/state";
import { RootState } from "../store/root";
import { PcmModal } from "../components/modals/pcm-modal.component";
import { NotificationService } from "../services/notification.service";

@Component({
    selector: "zbd-agent",
    templateUrl: "agent.component.html",
    styleUrls: ["agent.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentComponent {
    @ViewChild(PcmModal) pcmModal: PcmModal;

    consultationProcess$: Observable<ConsultationProcess>;
    validity$: Observable<AgentValidity>;

    ZASConstants = ZASConstants;
    strings = Strings;
    JSON = JSON;
    getKeys = Object.keys;

    constructor(
        public persistence: PersistenceService,
        store: Store<RootState>,
        private notify: NotificationService,
    ) {
        this.consultationProcess$ = store
            .select<ConsultationProcess>((s) => s.model.ConsultationProcess)
            .pipe(filter((x) => x !== undefined));
        this.validity$ = store.select<AgentValidity>((s) => s.validity.agent);
    }

    tenantTypeUpdateFn(cp: ConsultationProcess) {
        return (
            consultationProcess: ConsultationProcess,
            property: keyof ConsultationProcess,
            value: any,
            flush: boolean,
        ) => {
            const isDA = value === "DA";
            this.persistence.updateConsultationProcess(
                consultationProcess,
                property,
                value,
                !isDA,
            );
            if (isDA) {
                this.persistence.updateConsultationProcess(
                    consultationProcess,
                    "IsProfileHanded",
                    false,
                    true,
                );
            }
        };
    }

    isLocked(cp: ConsultationProcess): boolean {
        return cp.Agent.ExternalId != null;
    }

    showPCM() {
        this.pcmModal.open();
    }
}
